import { useState } from 'react';
import { getMonitoring } from '../service/getMonitoring';

export const useLocalStorage = <T>(key: string, initialValue: T) => {
  const monitoring = getMonitoring();

  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      monitoring.trackException(error);
      return initialValue;
    }
  });

  const setValue = (value: T) => {
    const valueToStore = value instanceof Function ? value(storedValue) : value;
    setStoredValue(valueToStore);
    window.localStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue];
};
